import {observer} from "mobx-react";
import * as React from "react";
import {IGDPRItem} from "components/signup/shared/IGDPRItem";
import {action, computed} from "mobx";

@observer
export class GDPRItemComponent extends React.Component<{ item: IGDPRItem, checkGDPR: boolean, onClick:()=>void }> {

  @computed
  get acceptanceRequiredAndNotGiven() {
    return this.props.checkGDPR && !this.props.item.accepted;
  }

  @action
  handleClick = () => {
    this.props.item.accepted = !this.props.item.accepted;
    this.props.onClick();
  }

  render() {
    return (
      <li>
        <div role={"checkbox"} className={`accept${this.acceptanceRequiredAndNotGiven?' invalid':''}`} aria-checked={this.props.item.accepted} tabIndex={0} onClick={this.handleClick}>
          <a className="checkbox noselect">
            <i aria-hidden={true} className="material-icons">{this.props.item.accepted ? 'check_box' : 'check_box_outline_blank'}</i>
            {this.props.item.initialDescription}
          </a>
        </div>
      </li>
    );
  }
}
